import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { StudentInfo } from "../student/studentSlice";

export interface ClassroomStudentAddState {
  state: LoadStateInfo;
  student?: StudentInfo;
}

const initialState: ClassroomStudentAddState = {
  state: notStarted(),
};

export interface ClassroomStudentAddRequest {
  classroomId: string;
  student: StudentInfo;
}
export const classroomInsertStudent = createAsyncThunk(
  "classroomInsStudent",
  async (param: ClassroomStudentAddRequest, thunkAPI) => {
    console.debug( `classroom add student ${param.student.id} to ${param.classroomId}`);
    const response = await fetch(`${getBackendUrl()}/api/classroom/${param.classroomId}/student/${param.student.id}`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    if(response.ok) {
      return "OK";
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const classroomStudentAddSlice = createSlice({
  name: "classroomStudentAddSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.student = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(classroomInsertStudent.pending, (state, action) => {
        state.state =  loading();
        state.student = action.meta.arg.student;
      })
      .addCase(classroomInsertStudent.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(classroomInsertStudent.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = classroomStudentAddSlice.actions;

export const selectClassroomStudentAdd = (state: RootState) => state.classroomStudentAdd;

export default classroomStudentAddSlice.reducer;
